<script lang="ts" setup>
  import { Toaster as Sonner, type ToasterProps } from 'vue-sonner';

  const props = defineProps<ToasterProps>();
</script>

<template>
  <Sonner
    class="toaster group whitespace-pre-line"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group-[.toaster]:border-border group-[.toaster]:shadow-sm rounded-2xl ' +
          'group-[.toaster]:rounded-sm group-[.toaster]:py-3',
        description: 'group-[.toast]:text-foreground-muted',
        actionButton:
          'group-[.toast]:bg-transparent group-[.toast]:text-blue group-[.toast]:hover:underline group-[.toast]:p-0 group-[.toast]:border-0',
        cancelButton:
          'group-[.toast]:bg-muted group-[.toast]:text-foreground-muted',
        success:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-success',
        warning: 'group-[.toaster]:bg-white group-[.toaster]:text-warning',
        error: 'group-[.toaster]:bg-white group-[.toaster]:text-destructive',
        info: 'group-[.toaster]:bg-white group-[.toaster]:text-foreground',
      },
    }"
  />
</template>
